module.exports = __webpack_public_path__ + "static/contact-347dd123c9996e56dafc6dac9380a870.svg";